import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Action, select, Store} from '@ngrx/store';
import {L10nTranslationService} from 'angular-l10n';
import {catchError, delayWhen, filter, map, switchMap, withLatestFrom} from 'rxjs/operators';

import {debug} from '../../../rxjs-operators';
import {LoadTimezonesFailAction, LoadTimezonesSuccessAction, TimezonesActionTypes} from '../actions/timezones';
import {error} from '../actions/toasts';
import {ArrayResponse} from '../models/array-response';
import {SendBackResult} from '../models/send-back-result';
import {Timezone} from '../models/timezone';
import {TimezonesService} from '../services/timezones.service';

import {BaseEffect} from './base.effect';
import * as fromRoot from '../reducers';
import * as _ from 'lodash';
import {clientConfigurationActionTypes, LoadClientConfigurationSuccessAction} from '../actions/client-configuration';
import {ClientConfigurationService} from '../services/client-configuration.service';

@Injectable()
export class ClientConfigurationEffect extends BaseEffect {
  private client$ = this.store.pipe(select(fromRoot.selectors.getCurrentClient)).pipe(filter(client => !_.isEmpty(client)));
  load$ = createEffect(
    () => {  return this.actions$.pipe(ofType(clientConfigurationActionTypes.LOAD),
                                        delayWhen(() => this.client$),
                                        debug('Load counters action received.'),
                                        withLatestFrom(this.client$),
                                         switchMap(([action, client]) => this.clientConfigurationService.getList(client.uuid).pipe(
                                         map((payload: SendBackResult<ArrayResponse<any>>) => new LoadClientConfigurationSuccessAction(payload.data.array)),
                                         catchError((res: Response) => this.catchResponseError(res)))))});

  loadFail$ = createEffect(
    () => {  return this.actions$.pipe(ofType(clientConfigurationActionTypes.LOAD_FAIL),
                                 debug('Load clientConfiguration fail action received.'),
                                 map(() => error(this.translation.translate('TIMEZONES_LOAD_ERROR'),
                                   this.translation.translate('TOAST_ERROR_TITLE'))))});

  constructor(private actions$: Actions,
              translation: L10nTranslationService,
              private store: Store<fromRoot.AppState>,
              private clientConfigurationService: ClientConfigurationService,
              router: Router) {
    super(router, translation);
  }

  protected handleUnhandledError(response: Response): Action { return new LoadTimezonesFailAction(response.status); }
}
